export default function createTodoResolvedData(firebase, { user = null }) {
	return {
		status: true,
		timestamp: firebase.firestore.FieldValue.serverTimestamp(),
		user,
	};
}
